'use strict';

module.exports = {
    MAXIMUM_EXPERIENCE: 100,
    MAXIMUM_LEVEL: 100
};
